import { render, staticRenderFns } from "./AppFooter.vue?vue&type=template&id=4747347b&scoped=true&"
import script from "./AppFooter.vue?vue&type=script&lang=js&"
export * from "./AppFooter.vue?vue&type=script&lang=js&"
import style0 from "./AppFooter.vue?vue&type=style&index=0&id=4747347b&prod&lang=scss&scoped=true&"
import style1 from "./AppFooter.vue?vue&type=style&index=1&id=4747347b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747347b",
  null
  
)

export default component.exports